import React from "react";
import PropTypes from "prop-types";

import { titanTierTitle } from "@/common/titan_plans";
import styles from "./domain_select.module.scss";

/**
 * Domain switcher for the email step, showing which Titan tier (if any)
 * each domain already has in the cart.
 */
function DomainSelect({ domains, activeDomain, titanServiceTypes, onSelect }) {
  if (domains.length < 2) return null;

  const labelFor = (domain) => {
    const serviceType = titanServiceTypes[domain];
    return serviceType
      ? `${domain} - Titan ${titanTierTitle(serviceType)}`
      : `${domain} - no email yet`;
  };

  return (
    <select
      data-test-id="domain-select"
      aria-label="Domain to configure Titan Email for"
      className={styles.domain_select}
      value={activeDomain}
      onChange={(e) => onSelect(e.target.value)}
    >
      {domains.map((domain) => (
        <option key={domain} value={domain}>
          {labelFor(domain)}
        </option>
      ))}
    </select>
  );
}

DomainSelect.propTypes = {
  activeDomain: PropTypes.string.isRequired,
  domains: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  titanServiceTypes: PropTypes.object.isRequired
};

export default DomainSelect;
